document.addEventListener('alpine:init', function () {
    Alpine.data('serviceSelector', function (defaultTab) {
        if (defaultTab === void 0) { defaultTab = 0; }
        return {
            activeTab: defaultTab,
            tabCount: 0,
            init: function () {
                this.tabCount = this.$el.querySelectorAll('[role="tab"]').length;
                // Clamp to valid range
                if (this.activeTab >= this.tabCount)
                    this.activeTab = 0;
            },
            selectTab: function (index) {
                this.activeTab = index;
                this.$store.app.track({
                    event: 'click_service_selector_tab',
                    type: 'click',
                    trigger: 'tab',
                    module: 'service-selector',
                    data: {
                        tabIndex: index,
                    },
                });
            },
            isActive: function (index) {
                return this.activeTab === index;
            },
            onTabKeydown: function (event) {
                var nextIndex = null;
                switch (event.key) {
                    case 'ArrowRight':
                        nextIndex = (this.activeTab + 1) % this.tabCount;
                        break;
                    case 'ArrowLeft':
                        nextIndex = (this.activeTab - 1 + this.tabCount) % this.tabCount;
                        break;
                    case 'Home':
                        nextIndex = 0;
                        break;
                    case 'End':
                        nextIndex = this.tabCount - 1;
                        break;
                    default:
                        return;
                }
                event.preventDefault();
                this.selectTab(nextIndex);
                this.focusTab(nextIndex);
            },
            focusTab: function (index) {
                var tab = this.$root.querySelector("[role=\"tab\"][data-tab-index=\"".concat(index, "\"]"));
                tab === null || tab === void 0 ? void 0 : tab.focus();
            },
        };
    });
});
